import { gql } from '@apollo/client'

export default gql`
  fragment SyllabusListProjectImageComponent on ProductCourseProjectImage {
    id
    title
    description
    image {
      url
      blurhash
    }
  }
`
